import { useEffect, useMemo, useCallback } from 'react';
import './style.css'

// Components
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { ExpandMore, HighlightOffSharp } from '@mui/icons-material';
import ButtonBasic from '../../atoms/buttonBasic/view';
import Table from '../../molecules/tablas/view';
import ClientInfo from '../../atoms/ClientInfo/view';
import CustomBox from '../../atoms/container/container';
import CardProduct from '../../atoms/CardProduct/view';

// Context & Utils
import { useCarrito } from '../../../context/carrito/context';
import { EmptyArray } from '../../../app/domain/models/empty/empty';
import { formatMoney } from '../../../utils/formating';
import React from 'react';

function SellModule({
    type = "sell",
    children,
    removeItems,
    car,
    update,
    taxGroup,
    tercero,
    total,
    showDescription,
}) {
    const { clearCart, setType } = useCarrito();
    const valueType = useMemo(() => type === "buy" ? "buy_value" : "value", [type]);

    const hasServices = useMemo(() => {
        if (showDescription !== undefined) return Boolean(showDescription);
        return car?.some(item => Boolean(item.is_service ?? (item.type === 'service')));
    }, [car, showDescription]);

    useEffect(() => {
        setType(type);
    }, [type, setType]);

    const formattedCar = useMemo(() => {
        if (!car || car.length === 0) return EmptyArray;
        return car.map(item => {
            const isService = Boolean(item.is_service ?? (item.type === 'service'));
            const customDescription = item.description || item.name || '';

            const row = {
                name: item.name,
            };

            if (hasServices) {
                row.description = isService ? (
                    <button
                        type="button"
                        className='btn-desc-car'
                        onClick={() => update(item, 'description')}
                        title="Clic para editar descripción personalizada"
                    >
                        <span className={customDescription ? 'btn-desc-car-text' : 'btn-desc-car-placeholder'}>
                            {customDescription || '+ Añadir descripción'}
                        </span>
                    </button>
                ) : (
                    <span style={{ color: 'var(--color-gray-40)' }}>—</span>
                );
            }

            row.unitario = (
                <button className='btn-unit-car' onClick={() => update(item, 'value')}>
                    <p>{formatMoney(item[valueType] ?? 0)}</p>
                </button>
            );
            row.cantidad = (
                <button className='btn-unit-car' onClick={() => update(item, 'amount')}>
                    <p>{item.amount ?? 0}</p>
                </button>
            );
            row.subtotal = item.total ?? 0;
            row.actions = (
                <button onClick={() => removeItems(item)} className='del-item'>
                    <HighlightOffSharp />
                </button>
            );

            return row;
        });
    }, [car, update, valueType, removeItems, hasServices]);

    const headersList = useMemo(() => {
        if (hasServices) {
            return ["Nombre", "Descripción", "Unitario", "Cantidad", "SubTotal", ""];
        }
        return ["Nombre", "Unitario", "Cantidad", "SubTotal", ""];
    }, [hasServices]);

    const renderTaxes = useCallback(() => {
        return taxGroup?.map(tax => (
            <p key={tax?.metadata.name}>
                {`${tax?.metadata.name} (${tax?.metadata.value * 100}%) -> ${formatMoney(Math.round(tax.subtotal))}`}
            </p>
        ));
    }, [taxGroup]);

    return (
        <div className='sell-module'>
            <ClientInfo tercero={tercero} type={type} />
            <div className='sell-box-table'>
                <Table
                    title="Productos"
                    id='sellproducts'
                    headersList={headersList}
                    formats={{ subtotal: { type: 'money' } }}
                    data={formattedCar}
                    mobileCard={<CardProduct />}
                    allowSearch={false}
                />
            </div>
            <Accordion className='sell-total-box' style={{ boxShadow: "none" }}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography><span>Total {formatMoney(total)}</span></Typography>
                </AccordionSummary>
                <AccordionDetails className='details'>
                    {renderTaxes()}
                </AccordionDetails>
            </Accordion>
            <div className='sell-button-box'>
                <ButtonBasic onClick={clearCart}>Cancelar</ButtonBasic>
                {React.cloneElement(children, { car, total, tercero, type })}
            </div>
        </div>
    )
}

export default SellModule
